export default __webpack_public_path__ + "locales/si/DeleteProfileEverDialog.json?hash=98a663c323572eb0da7150e4c7fcfe72";